import { render, staticRenderFns } from "./YesNoConfig.vue?vue&type=template&id=02bfd8a3"
import script from "./YesNoConfig.vue?vue&type=script&lang=js"
export * from "./YesNoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02bfd8a3')) {
      api.createRecord('02bfd8a3', component.options)
    } else {
      api.reload('02bfd8a3', component.options)
    }
    module.hot.accept("./YesNoConfig.vue?vue&type=template&id=02bfd8a3", function () {
      api.rerender('02bfd8a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/YesNoConfig.vue"
export default component.exports